import type { TBulkAction } from '@/shared/model';
import { BULK_ACTION_ENUM } from '@/shared/model';
import {
  BeatNIcon as beatNIcon,
  BeatQIcon as beatQIcon,
  BeatSIcon as beatSIcon,
  BeatVIcon as beatVIcon,
  BlackDeleteIcon as blackDeleteIcon,
  BeatSwapTemplate as beatSwapTemplateIcon,
  UnreviewedIcon as reviewUnmarkIcon,
} from '@/shared/ui';

/**
 * Builds the per-cell bulk-action menu shown on a beat template cell, each entry carrying its beat icon. Lists the N, S, V, Q and delete-all entries, inserts the swap-the-template entry only in template mode, and always appends mark-as-reviewed.
 *
 * @param isTemplate - True when the cell belongs to a beat template, which adds the swap-the-template entry.
 * @returns The ordered menu entries with their labels, bulk action values and icons.
 */
const getBulkActionMenu = (isTemplate?: boolean) => {
  const menu: { label: string; value: TBulkAction; icon: string }[] = [
    {
      label: 'Change all to N beat',
      value: BULK_ACTION_ENUM.ALL_N,
      icon: beatNIcon,
    },
    {
      label: 'Change all to S beat',
      value: BULK_ACTION_ENUM.ALL_S,
      icon: beatSIcon,
    },
    {
      label: 'Change all to V beat',
      value: BULK_ACTION_ENUM.ALL_V,
      icon: beatVIcon,
    },
    {
      label: 'Change all to Q beat',
      value: BULK_ACTION_ENUM.ALL_Q,
      icon: beatQIcon,
    },
    {
      label: 'Delete all beats',
      value: BULK_ACTION_ENUM.ALL_DELETE,
      icon: blackDeleteIcon,
    },
  ];
  if (isTemplate) {
    menu.push({
      label: 'Swap the template',
      value: BULK_ACTION_ENUM.SWAP_TEMPLATE,
      icon: beatSwapTemplateIcon,
    });
  }
  menu.push({
    label: 'Mark as reviewed',
    value: BULK_ACTION_ENUM.MARK_REVIEWED,
    icon: reviewUnmarkIcon,
  });
  return menu;
};

export default getBulkActionMenu;
